const Internal = () =>
  import(
    /* webpackChunkName: "messages-internal" */ '@/pages/message/internal/internal/index.vue'
  )
const CreateInternal = () =>
  import(
    /* webpackChunkName: "messages-internal" */ '@/pages/message/internal/internal/create.vue'
  )
const EditInternal = () =>
  import(
    /* webpackChunkName: "messages-internal" */ '@/pages/message/internal/internal/edit.vue'
  )

export default {
  path: 'internal',
  meta: {
    label: 'internal',
    auth: 'internal'
  },
  component: {
    name: 'Internal',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'MessageInternalInternal',
      path: '',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: Internal
    },
    {
      name: 'MessageCreateInternalInternal',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: CreateInternal
    },
    {
      name: 'MessageEditInternalInternal',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: EditInternal,
      props: true
    }
  ]
}
